import { baseApi } from 'services'

export const userDataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsersData: builder.query<any, void | boolean>({
      query: (staff) => `v2/user/?is_staff=${staff}`,
      providesTags: ['ApplicationAllUsersData'],
    }),
    getUserData: builder.query<any, number>({
      query: (user_id) => `v2/user/${user_id}/`,
    }),
    updateUserData: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/${data.id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['ApplicationAllUsersData', 'UserData'],
    }),
    createUserData: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ApplicationAllUsersData'],
    }),
    deleteUser: builder.mutation<any, number>({
      query: (uuid) => ({
        url: `v2/user/${uuid}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ApplicationAllUsersData'],
    }),
    updateUserPermissionGroups: builder.mutation<any, any>({
      query: ({ id, groups }) => ({
        url: `v2/user/${id}/set-groups/`,
        method: 'PATCH',
        body: groups,
      }),
      invalidatesTags: ['ApplicationAllUsersData'],
    }),
  }),
})

export const {
  useGetAllUsersDataQuery,
  useCreateUserDataMutation,
  useUpdateUserDataMutation,
  useGetUserDataQuery,
  useLazyGetUserDataQuery,
  useUpdateUserPermissionGroupsMutation,
  useDeleteUserMutation,
} = userDataApi
